import { defineStore } from 'pinia';
import { CardType } from "@/constants/constants";

const BALANCE_FIELD_PREPAY = "prepayBalanceCash";
const CENT_FACTOR = 100;

function toCents(value) {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? Math.round(numberValue * CENT_FACTOR) : null;
}

function sumPendingTopUpsCents(pendingTopups = []) {
  return pendingTopups.reduce((sum, item) => {
    const amountCents = toCents(item?.amount);
    return amountCents === null ? sum : sum + amountCents;
  }, 0);
}

function supportsPrepayTopUp(cardType) {
  return [
    CardType.PREPAYMENT,
    CardType.PREPAYMENT_AND_CREDIT,
    CardType.CREDIT_AND_PREPAYMENT,
  ].includes(cardType);
}

export const useTopUpRefreshStore = defineStore('topUpRefresh', {
  state: () => ({
    pendingRefresh: null,
  }),

  getters: {
    hasConfirmedPendingRefresh: (state) => !!state.pendingRefresh?.paymentConfirmed,
  },

  actions: {
    prepare(amount, wondCustomer) {
      if (!wondCustomer || !supportsPrepayTopUp(wondCustomer.cardType)) {
        this.clear();
        return false;
      }

      const amountCents = toCents(amount);
      const initialBalanceCents = toCents(wondCustomer[BALANCE_FIELD_PREPAY]);

      if (amountCents === null || initialBalanceCents === null) {
        this.clear();
        return false;
      }

      this.pendingRefresh = {
        amountCents,
        balanceField: BALANCE_FIELD_PREPAY,
        cardNum: wondCustomer.cardNum,
        cardType: wondCustomer.cardType,
        createdAt: Date.now(),
        expectedBalanceCents: initialBalanceCents + amountCents,
        initialBalanceCents,
        initialPendingTopUpsCents: sumPendingTopUpsCents(wondCustomer.pendingTopup),
        paymentConfirmed: false,
        confirmedAt: null,
      };

      return true;
    },
    confirmPayment() {
      if (!this.pendingRefresh) {
        return;
      }

      this.pendingRefresh.paymentConfirmed = true;
      this.pendingRefresh.confirmedAt = Date.now();
    },
    isSatisfiedBy(wondCustomer) {
      if (!this.pendingRefresh || !wondCustomer) {
        return false;
      }

      if (this.pendingRefresh.cardNum && wondCustomer.cardNum && this.pendingRefresh.cardNum !== wondCustomer.cardNum) {
        return false;
      }

      const currentBalanceCents = toCents(wondCustomer[this.pendingRefresh.balanceField]);
      if (currentBalanceCents !== null && currentBalanceCents >= this.pendingRefresh.expectedBalanceCents) {
        return true;
      }

      const currentPendingTopUpsCents = sumPendingTopUpsCents(wondCustomer.pendingTopup);
      return currentPendingTopUpsCents >= this.pendingRefresh.initialPendingTopUpsCents + this.pendingRefresh.amountCents;
    },
    clear() {
      this.pendingRefresh = null;
    },
  },

  persist: {
    storage: sessionStorage,
  },
});
